import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NgrxService } from 'src/app/services/ngrx/ngrx.service';
import { map } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class PropertyService {
	constructor(private http: HttpClient, private ngrxService: NgrxService) {
		//
	}
	loadPropertyinit(cohortId: any) {
		return this.ngrxService.loadInitAPI('Property', 'list', cohortId);
	}

	loadPropertyapi(cohortId: any) {
		return this.getPropertyLists(cohortId).pipe(
			map((data: any) => {
				console.log(data, 'hr');
				return this.ngrxService.loadInitData(
					'Property',
					'list',
					cohortId,
					data,
				);
			}),
		);
	}

	fetchPropertydata(cohortId: any) {
		return this.ngrxService.loadData('Property', 'list', cohortId);
	}
	getPropertyLists(cohortId: any) {
		return this.http.get(
			environment.url.cohort + `/list/cohort/${cohortId}/property`,
			// return this.http.get(environment.url.cohort + '/list/cohort/$id/property');
		);
	}
}
